import { render, staticRenderFns } from "./paymentPage.vue?vue&type=template&id=d07700dc&scoped=true&"
import script from "./paymentPage.vue?vue&type=script&lang=js&"
export * from "./paymentPage.vue?vue&type=script&lang=js&"
import style0 from "./paymentPage.vue?vue&type=style&index=0&id=d07700dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07700dc",
  null
  
)

export default component.exports